import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import {
  prefixCurriculumName,
  setSubChildId,
} from "Administrator/modules/AdministratorModule";
import { CREATE_EVALUATION_CRITERIA } from "Constants/stringConstants";
export default store => ({
  path: "create-evaluation-criteria",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import("./components"),
        import("../../../EvaluationCriteria/modules/EvaluationCriteriaModule"),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "evaluationCriteria",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter() {
    const state = store.getState();
    const curriculumProgramId = _.get(
      state,
      "platform.currentCurriculumProgram.id"
    );
    const childId = store.dispatch(
      prefixCurriculumName({
        childId: CREATE_EVALUATION_CRITERIA,
        curriculumProgramId,
      })
    );
    store.dispatch(setSubChildId(childId));
  },
  onLeave() {
    store.dispatch(setSubChildId(""));
  },
});
